import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { fetchSixDetailMetaAndFilesThunk } from '@/store/thunks/sixDetail/fetchMetaAndFilesThunk';

export const deleteFolderThunk = createAppAsyncThunk<
  undefined,
  { sixId: string; folderPath: string }
>(
  'sixDetail/deleteFolder',
  withLoader(
    async({ sixId, folderPath }, { extra, dispatch }) => {
      await extra.sixDetailService.deleteFolder(sixId, folderPath);
      await dispatch(fetchSixDetailMetaAndFilesThunk(sixId)).unwrap();
      return undefined;
    }
  )
);
